import { render, staticRenderFns } from "./customer-confirmation.vue?vue&type=template&id=05db2aa2&scoped=true&"
import script from "./customer-confirmation.vue?vue&type=script&lang=js&"
export * from "./customer-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./customer-confirmation.vue?vue&type=style&index=0&id=05db2aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db2aa2",
  null
  
)

component.options.__file = "customer-confirmation.vue"
export default component.exports